import { CheckRounded, FilterListRounded, KeyboardArrowDownRounded } from "@mui/icons-material";
import { Badge, Button, Menu, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useState } from "react";

enum FilterPickerFilterNames {
  ShowNotStarted = "Show Not Started",
  ShowNotSubmitted = "Show Not Submitted",
  ShowSubmitted = "Show Submitted",
}

interface Props {
  selectedFilters: FilterPickerFilterNames[];
  onChange: (selectedFilters: FilterPickerFilterNames[]) => void;
}

const FilterPicker = (props: Props) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <Badge color="primary" variant="dot" invisible={props.selectedFilters.length === 0}>
        <Button
          variant="tertiary"
          startIcon={<FilterListRounded />}
          endIcon={<KeyboardArrowDownRounded />}
          onClick={(e) => setMenuAnchor(e.currentTarget)}
        >
          {props.selectedFilters.length > 0 && `${props.selectedFilters.length} `}Filters
        </Button>
      </Badge>

      <Menu
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        anchorEl={menuAnchor}
        slotProps={{
          paper: {
            sx: { minWidth: 225 },
          },
        }}
      >
        <ToggleButtonGroup
          value={props.selectedFilters}
          orientation="vertical"
          variant="menu"
          onChange={(_, filterNames: FilterPickerFilterNames[]) => props.onChange(filterNames)}
          sx={{ minWidth: "100%" }}
        >
          {[
            FilterPickerFilterNames.ShowNotStarted,
            FilterPickerFilterNames.ShowNotSubmitted,
            FilterPickerFilterNames.ShowSubmitted,
          ].map((x, i) => (
            <ToggleButton key={i} value={x}>
              <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                <Typography>{x}</Typography>
                {props.selectedFilters.includes(x) && <CheckRounded />}
              </Stack>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Menu>
    </>
  );
};

export { FilterPicker, FilterPickerFilterNames };
